import { createAction, props } from '@ngrx/store';

export const loadComments = createAction(
  '[Course Comments] Load Comments',
  props<{ courseId: number; itemId?: number; itemType?: string }>(),
);

export const loadCommentsSuccess = createAction(
  '[Course Comments] Load Comments Success',
  props<{ comments: any[] }>(),
);

export const loadCommentsFailure = createAction(
  '[Course Comments] Load Comments Failure',
  props<{ error: any }>(),
);

export const addComment = createAction(
  '[Course Comments] Add Comment',
  props<{ courseId: number; payload: any }>(),
);

export const addCommentSuccess = createAction(
  '[Course Comments] Add Comment Success',
  props<{ comment: any }>(),
);

export const addCommentFailure = createAction(
  '[Course Comments] Add Comment Failure',
  props<{ error: any }>(),
);

// Update Comment
export const updateComment = createAction(
  '[Course Comments] Update Comment',
  props<{ courseId: number; commentId: string; payload: any }>(),
);

export const updateCommentSuccess = createAction(
  '[Course Comments] Update Comment Success',
  props<{ comment: any }>(),
);

export const updateCommentFailure = createAction(
  '[Course Comments] Update Comment Failure',
  props<{ error: any }>(),
);

// Local Update (for UI state like read_status, preventing backend calls)
export const updateCommentLocal = createAction(
  '[Course Comments] Update Comment Local',
  props<{ commentId: string; changes: any }>(),
);

// Delete Comment
export const deleteComment = createAction(
  '[Course Comments] Delete Comment',
  props<{ courseId: number; commentId: string }>(),
);

export const deleteCommentSuccess = createAction(
  '[Course Comments] Delete Comment Success',
  props<{ commentId: string }>(),
);

export const deleteCommentFailure = createAction(
  '[Course Comments] Delete Comment Failure',
  props<{ error: any }>(),
);
